var routeActions = require('react-router-redux').routerActions;
var api = require('../../../utils/api');
var constants = require('../constants');
var surveyActions = require('../../survey/actions/surveys-initialize');
var commonActions = require('../../common/actions/common');
var dashboardActions = require('../../dashboard/actions/dashboard');
var surveyMetaActions = require('../../meta/actions/survey');

var PostResponse = (function() {
    
    var _surveyType2SubmissionType = {
        'promis': 'PROMIS', // Symptom Tracker
        'myqol': 'MQOL', // MyQ Quality of Life
        'gihistory': 'GIHistory' // Doctor Visit Preparation
    };

    var _surveyType2DashboardType = {
        'promis': 'mygi',
        'myqol': 'myqol',
        'gihistory': 'doctor-visit'
    };

    var _submissionRequest = function() {
        return {
            type: constants.SUBMISSION_REQUEST
        };
    }

    var _submissionSuccess = function() {
        return {
            type: constants.SUBMISSION_SUCCESS
        };
    }

    var _submissionError = function(error) {
        return {
            type: constants.SUBMISSION_ERROR,
            errors: error.data
        };
    }

    var _prepareSubmission = function(submission, state) {
        var surveyId = null;
        var sub = [];
        var entities = state.entities;
        var submissionType = _surveyType2SubmissionType[state.surveys.surveyType];

        for (var i = 0; i < submission.length; i++) {
            var nextSurveyId = submission[i][0];
            if (nextSurveyId !== surveyId) {
                surveyId = nextSurveyId;

                var symptomId = entities.surveys[surveyId].symptom;
                var symptom = entities.symptoms[symptomId];
                // var calculateScores = entities.surveys[surveyId].calculateScores || false;

                var survey = {
                    id: surveyId,
                    name: entities.surveys[surveyId].name
                }

                sub.push({
                    survey: survey,
                    symptom: symptom,
                    // calculateScores: calculateScores,
                    data: []
                });
            }

            var ans = {
                fieldName: submission[i][1],
                response: submission[i][2]
            };
            sub[sub.length - 1].data.push(ans);

        }
        return { type: submissionType, responses: sub };
    }

    var _postSubmission = function(accessToken) {
        return function(dispatch, getState) {
            var state = getState();
            var submission = state.responses.submission;
            var sub = _prepareSubmission(submission, state);
            
            dispatch(_submissionRequest());
            api.post('/proxy/v1/submissions', sub, accessToken)
                .then(function(res) {
                    dispatch(surveyMetaActions.recordSurveyCompleted(state.routing.locationBeforeTransitions.pathname.toLowerCase()));

                    dispatch(surveyActions.clearPreviousState());

                    var alarmSymptomResponses = [];
                    for(var i = 0; i < submission.length; i++){
                        var submissionItem = submission[i];
                        if(submissionItem[1] === 'D2A'){
                            alarmSymptomResponses = submissionItem[2].filter(function(userResponse){
                                return userResponse.tag !== 'none';
                            });
                        }
                    }
                    dispatch(dashboardActions.setAlarmSymptomResponses(alarmSymptomResponses));

                    // cause the score is generated asynchronously, we need a delay here
                    setTimeout(function(){
                        dispatch(_submissionSuccess());
                        dispatch(routeActions.replace('/dashboard/' + _surveyType2DashboardType[state.surveys.surveyType]));
                    }, 1000);
                })
                .catch(function(error) {
                    if(error.response){
                        dispatch(_submissionError(error.response));
                        dispatch(commonActions.setGenericResponseError('', error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        };
    }


    return {
        postSubmission: _postSubmission
    }
})();

module.exports = PostResponse;


// WEBPACK FOOTER //
// ./src/common/modules/responses/actions/post-responses.js